// Lightweight performance reporting helper compatible with different `web-vitals` typings
// Accepts an optional callback that's called with each metric (any) when available.
const reportWebVitals = (onPerfEntry?: (metric: any) => void): void => {
    if (onPerfEntry && typeof onPerfEntry === 'function') {
        // Use a dynamic import and cast to `any` to avoid depending on specific `web-vitals` types
        import('web-vitals').then((wv: any) => {
            if (typeof wv.getCLS === 'function') wv.getCLS(onPerfEntry)
            if (typeof wv.getFID === 'function') wv.getFID(onPerfEntry)
            if (typeof wv.getFCP === 'function') wv.getFCP(onPerfEntry)
            if (typeof wv.getLCP === 'function') wv.getLCP(onPerfEntry)
            if (typeof wv.getTTFB === 'function') wv.getTTFB(onPerfEntry)
        })
    }
}

export default reportWebVitals
